/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PointSystemBundle {
    REWARD_POINTS = 'RewardPoints',
}
